<template>
  <el-table
    id="cartTable"
    ref="multipleTable"
    :data="tableData"
    tooltip-effect="dark"
    style="width: 100%"
    :header-cell-style="
      tableHead ? { background: '#000', color: '#fff', height: '49px', textAlign: 'center' } : { display: 'none' }
    "
    row-key="id"
    :cell-style="{ textAlign: 'center' }"
    row-class-name="tableRow"
    cell-class-name="tableCell"
  >
    <el-table-column label="全选" width="62">
      <!-- 不是搭配购且不是买赠可以勾选 -->
      <template slot-scope="scoped" v-if="!scoped.row.collocation && !scoped.row.gift">
        <el-checkbox v-model="scoped.row.isSelect" v-if="tableHead" @change="handleSelect"></el-checkbox>
        <img v-if="!tableHead" src="../../../assets/images/mall/overdue.png" />
      </template>
    </el-table-column>
    <el-table-column label="商品信息" width="500">
      <template slot-scope="scoped">
        <div style="cursor: pointer" class="goodsMessage" @click="toDetails(scoped.row)">
          <div class="goodsImg">
            <img  :src="scoped.row.thumbnail" mode="widthFix" />
          </div>
          <div class="text">
            <div class="name" :style="tableHead ? '' : { color: '#999' }">
              <span
                :class="
                  (scoped.row.activityItemInfoDto &&
                    scoped.row.activityItemInfoDto.activityInfoDto &&
                    scoped.row.activityItemInfoDto.activityInfoDto.activityType == 18) ||
                  scoped.row.activityItemInfoDto.activityInfoDto.activityType == 21
                    ? 'deposit-tag activityTag'
                    : 'activityTag'
                "
                v-if="
                  scoped.row.activityItemInfoDto &&
                  scoped.row.activityItemInfoDto.activityInfoDto &&
                  scoped.row.activityItemInfoDto.activityInfoDto.activityTag &&
                  scoped.row.activityItemInfoDto.activityInfoDto.activityType !== 25
                "
                >{{ scoped.row.activityItemInfoDto.activityInfoDto.activityTag }}</span
              >
              <span v-if="scoped.row.gift" class="activityTag"> 赠品</span>
              <span v-if="scoped.row.collocation" class="activityTag"> 搭配购</span>
              <!-- <span
                v-if="
                  scoped.row.activityItemInfoDto &&
                    scoped.row.activityItemInfoDto.activityInfoDto &&
                    scoped.row.activityItemInfoDto.activityInfoDto.activityType == 18
                "
                class="deposit-tag activityTag"
              >
                订金升档
              </span> -->
              <span
                class="activityTag"
                v-if="
                  scoped.row.activityItemInfoDto &&
                  scoped.row.activityItemInfoDto.activityInfoDto &&
                  !scoped.row.activityItemInfoDto.activityInfoDto.activityTag
                "
                >{{ activityTag[scoped.row.activityItemInfoDto.activityInfoDto.activityType] }}</span
              >
              {{ scoped.row.itemName }}
            </div>
            <div class="type" :style="tableHead ? '' : { color: '#999' }">
              <div v-for="(item, index) in scoped.row.skuAttr" :key="index">
                <span>{{ item.attrKey }}:{{ item.attrVal }}</span>
              </div>
            </div>
            <div class="sellOut" v-if="!tableHead">{{ scoped.row.isValidCause }}</div>
            <div v-if="scoped.row.activityItemInfoDto && scoped.row.activityItemInfoDto.activityInfoDto && tableHead">
              <!-- <img src="@/assets/images/seller/time-count.png" /> -->
              <CountDown
                class="activityCountDown"
                v-if="
                  scoped.row.activityItemInfoDto.activityInfoDto.realStartTime > now
                    ? scoped.row.activityItemInfoDto.activityInfoDto.realStartTime
                    : scoped.row.activityItemInfoDto.activityInfoDto.realEndTime > now
                    ? scoped.row.activityItemInfoDto.activityInfoDto.realEndTime
                    : ''
                "
                :endTime="
                  scoped.row.activityItemInfoDto.activityInfoDto.realStartTime > now
                    ? scoped.row.activityItemInfoDto.activityInfoDto.realStartTime
                    : scoped.row.activityItemInfoDto.activityInfoDto.realEndTime > now
                    ? scoped.row.activityItemInfoDto.activityInfoDto.realEndTime
                    : ''
                "
                :text="
                  scoped.row.activityItemInfoDto.activityInfoDto.realStartTime > now
                    ? '距离开始还有'
                    : scoped.row.activityItemInfoDto.activityInfoDto.realEndTime > now
                    ? '距离结束还有'
                    : '活动已结束'
                "
                @timeEnd="handleCountDown"
              />
              <span class="activityCountDown" v-else>活动已结束</span>
            </div>
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="snapshotPrice" label="单价">
      <template slot-scope="scoped">
        <div class="price" :style="tableHead ? { cursor: 'pointer' } : { color: '#999', cursor: 'pointer' }">
          {{
            scoped.row.activityItemInfoDto && scoped.row.activityItemInfoDto.activityInfoDto
              ? scoped.row.activityItemInfoDto.activityInfoDto.activityType == 18
                ? scoped.row.snapshotPrice
                : scoped.row.activityPrice
              : scoped.row.snapshotPrice | currency('￥', 2)
          }}
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="quantity" label="数量" show-overflow-tooltip>
      <template slot-scope="scoped">
        <span
          v-if="
            (scoped.row.activityItemInfoDto &&
              scoped.row.activityItemInfoDto.activityInfoDto &&
              scoped.row.activityItemInfoDto.activityInfoDto.activityType === 2) ||
            scoped.row.collocation
          "
          >{{ scoped.row.quantity }}</span
        >
        <el-input-number
          v-else
          :disabled="
            !tableHead ||
            scoped.row.itemType === 0 ||
            scoped.row.gift ||
            (scoped.row.activityItemInfoDto && scoped.row.activityItemInfoDto.activityInfoDto.activityType === 21)
          "
          size="small"
          :precision="0"
          v-model="scoped.row.quantity"
          :min="1"
          :max="
            scoped.row.buyLimit &&
            scoped.row.buyLimit < 99 &&
            scoped.row.activityItemInfoDto &&
            scoped.row.activityItemInfoDto.activityInfoDto &&
            scoped.row.activityItemInfoDto.activityInfoDto.activityType != 6
              ? scoped.row.buyLimit
              : scoped.row.stockQuantity && scoped.row.stockQuantity < 99
              ? scoped.row.stockQuantity
              : 99
          "
          @change="inputChange(scoped.row.id, scoped.row.quantity)"
          label="描述文字"
        ></el-input-number>
      </template>
    </el-table-column>
    <el-table-column prop="totalPrice" label="小计">
      <template slot-scope="scoped">
        <div class="totalPrice" :style="tableHead ? { cursor: 'pointer' } : { color: '#999', cursor: 'pointer' }">
          {{
            (parseInt(
              scoped.row.activityItemInfoDto && scoped.row.activityItemInfoDto.activityInfoDto
                ? scoped.row.activityItemInfoDto.activityInfoDto.activityType == 18
                  ? scoped.row.snapshotPrice
                  : scoped.row.activityPrice
                : scoped.row.snapshotPrice
            ) *
              parseInt(scoped.row.quantity))
              | currency('￥', 2)
          }}
        </div>
      </template>
    </el-table-column>
    <!-- <el-table-column label="">
      <template slot-scope="scoped"
        ><el-button type="text" v-if="scoped.row.children" @click.native="handleToogleExpand(scoped.row)">{{
          scoped.row.show ? '收起搭配商品' : '查看搭配商品'
        }}</el-button>
      </template>
    </el-table-column> -->
    <el-table-column label="">
      <template slot-scope="scoped" v-if="!scoped.row.collocation && !scoped.row.gift">
        <div @click="goodsDelete(scoped.row.id)" style="cursor: pointer">
          <img style="width: 14px; height: 14px" src="../../../assets/images/seller/delete.png" />
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import store from '@/lib/store'
import getData from '@api/details'
import { _throttle, getStorage } from '@/lib/utils'
import CountDown from '@/components/common/CountDown'
import { getCanGiveCouponDetail } from '@api/coupon'
export default {
  name: 'tableCar',
  inject: ['reload'],
  components: { CountDown },
  props: {
    tableData: Array,
    tableHead: Boolean,
    selectAll: {
      type: Boolean,
      default: false
    },
    now: Number /* 刷新页面时时间戳 */
  },
  data() {
    return {
      buyLimit: 0,
      // cartItems: [],
      // offShelf: [],
      // sellout: [],
      activityTag: {
        2: '搭配购',
        3: '抽奖类',
        5: '限时抢购',
        6: '团购',
        8: '集客',
        9: '主题',
        10: '投票',
        11: '裂变',
        14: '签到集卡',
        16: '邀请下单',
        18: '预售',
        19: '神券',
        20: '拍卖',
        21: '买赠'
      },
      activityPrice: 0,
      store,
      cartData: {
        selectNum: 0,
        totalPrice: 0,
        discountPrice: 0,
        selectTableData: []
      }
    }
  },
  watch: {
    selectAll() {
      this.handleAllSelect()
    },
    tableData() {
      this.init()
    }
  },
  mounted() {
    // this.handleAllSelect()
    this.$emit('fromtable', this.cartData)
    // this.init()
  },
  methods: {
    expandAllRow() {
      this.tableData.map((item) => {
        const $table = this.$refs.multipleTable
        $table.toggleRowExpansion(item, true)
      })
    },
    handleToogleExpand(row) {
      if (!('show' in row)) {
        this.$set(row, 'show', true)
      } else {
        this.$set(row, 'show', !row.show)
      }
      let $table = this.$refs.multipleTable
      this.tableData.map((item) => {
        if (row.id !== item.id) {
          this.$set(item, 'show', false)
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row, row.show)
    },
    init() {
      this.tableData.map((res) => {
        if (res.activityItemInfoDto && typeof res.activityItemInfoDto === 'string') {
          res.activityItemInfoDto = JSON.parse(res.activityItemInfoDto)
        }
        if (res.activityItemInfoDto && res.activityItemInfoDto.activityItemDtoList) {
          res.activityItemInfoDto.activityItemDtoList.map((item) => {
            if (Number(res.skuId) === Number(item.skuId)) {
              if (
                res.activityItemInfoDto &&
                res.activityItemInfoDto.activityInfoDto &&
                res.activityItemInfoDto.activityInfoDto.activityType === 18
              ) {
                this.$set(res, 'activityPrice', res.snapshotPrice)
              } else if (
                res.activityItemInfoDto &&
                res.activityItemInfoDto.activityInfoDto &&
                res.activityItemInfoDto.activityInfoDto.activityType !== 18
              ) {
                this.$set(res, 'activityPrice', item.itemExtDto.activityPrice)
              }
              this.$set(res, 'buyLimit', item.itemExtDto.buyLimit)
              this.$set(
                res,
                'originalPrice',
                Number(item.itemExtDto.originalPrice ? item.itemExtDto.originalPrice : res.snapshotPrice)
              )
            }
          })
        }
      })
    },
    handleCountDown() {
      this.reload()
      this.$parent.getCartData()
    },
    // 进入商品详情页
    toDetails(data) {
      // 如果是买赠商品，点击买赠商品跳转到主商品详情页
      if (data.gift) {
        this.tableData.forEach((item) => {
          if (data.acId === item.activityId) {
            this.toDetails(item)
          }
        })
        return
      }
      if (data.activityItemInfoDto && data.activityItemInfoDto.activityInfoDto) {
        let activityId = data.activityItemInfoDto.activityInfoDto.id
        if (data.itemType === 0) {
          this.$router.push({
            name: 'detailAllCars',
            query: {
              activityId: activityId,
              id: data.itemId,
              ladderIndex: data.extra && data.extra.ladderIndex,
              groupCode: data.extra.groupCode
            }
          })
        } else {
          this.$router.push({
            name: 'detailBoutiqueAccessories',
            query: {
              activityId: activityId,
              id: data.itemId,
              ladderIndex: data.extra && data.extra.ladderIndex
            }
          })
        }
      } else {
        if (data.itemType === 0) {
          this.$router.push({
            name: 'detailAllCars',
            query: {
              id: data.itemId
            }
          })
        } else {
          this.$router.push({
            name: 'detailBoutiqueAccessories',
            query: {
              id: data.itemId
            }
          })
        }
      }
      // if (data[0] === 0) {
      //   this.$router.push(cartActivityRoute(...data))
      // } else {
      //   this.$router.push(cartActivityRoute(...data))
      // }
    },
    // 修改商品数量
    changeNumber(id, num) {
      const data = [
        {
          id: id,
          quantity: num
        }
      ]
      getData.changeCartNumGroup(data).then(
        (res) => {},
        (res) => {
          this.$feedback(res.message)
        }
      )
    },
    // 全选
    handleSelectionChange(isSelect) {
      this.tableData.map((res) => {
        // res.isSelect = isSelect
        if (!res.gift) {
          this.$set(res, 'isSelect', isSelect)
        }
      })
      this.handleSelect()
    },
    handleAllSelect() {
      this.handleSelectionChange(this.selectAll)
    },
    // 选中商品
    handleSelect(row) {
      // 总价
      let totalPrice = 0
      // 折后价
      let discountPrice = 0
      let selectTableData = []
      this.tableData.map((res) => {
        if (res.isSelect && !res.collocation && !res.gift) {
          // 主商品加入选择数组中
          selectTableData.push(res)
          // 如果有赠品把赠品添加到selectTableData中
          if (res.bizCollectionCartItemVOS) {
            res.bizCollectionCartItemVOS.forEach((item) => {
              selectTableData.push(item)
            })
          }
        }
      })
      // 获得选中商品个数
      let num = 0
      selectTableData.forEach((obj) => {
        // 不是买赠的
        if (!obj.gift) {
          num++
        }
      })
      this.cartData.selectNum = num

      // 计算总价和折后价
      selectTableData.forEach((obj) => {
        // 不是买赠的
        if (!obj.gift) {
          totalPrice += (obj.originalPrice ? obj.originalPrice : obj.snapshotPrice) * obj.quantity
          discountPrice +=
            ((obj.originalPrice ? obj.originalPrice : obj.snapshotPrice) -
              (obj.activityPrice ? obj.activityPrice : obj.snapshotPrice)) *
            obj.quantity
        }
      })

      // selectTableData.forEach((obj2) => {})
      // totalPrice += (res.originalPrice ? res.originalPrice : res.snapshotPrice) * res.quantity
      // discountPrice +=
      //   ((res.originalPrice ? res.originalPrice : res.snapshotPrice) -
      //     (res.activityPrice ? res.activityPrice : res.snapshotPrice)) *
      //   res.quantity
      // // 对子商品进行折扣计算
      // res.bizCollectionCartItemVOS &&
      //   res.bizCollectionCartItemVOS.forEach((obj) => {
      //     totalPrice += (obj.originalPrice ? obj.originalPrice : obj.snapshotPrice) * obj.quantity
      //     discountPrice +=
      //       ((obj.originalPrice ? obj.originalPrice : obj.snapshotPrice) -
      //         (obj.activityPrice ? obj.activityPrice : obj.snapshotPrice)) *
      //       obj.quantity
      //   })

      this.cartData.totalPrice = totalPrice
      this.cartData.selectTableData = selectTableData
      this.cartData.discountPrice = discountPrice
      this.$emit('fromtable', this.cartData)
    },
    inputChange(id, num) {
      this.handleSelect()
      _throttle(this.changeNumber(id, num))
    },
    // 删除商品
    goodsDelete(index) {
      this.$confirm('亲，确定删除该商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.tableData.forEach((arrItem, arrIndex) => {
            if (arrItem.id === index) {
              this.tableData.splice(arrIndex, 1)
            }
          })
          // 把所有的商品都关闭掉
          let $table = this.$refs.multipleTable
          this.tableData.map((item) => {
            this.$set(item, 'show', false)
            $table.toggleRowExpansion(item, false)
          })
          // 准备调接口删除商品
          const carIds = []
          carIds.push(index)
          const data = {
            ids: carIds.join(',')
          }
          getData.deleteCartGroup(data).then((res) => {
            if (res.status === 200) {
              this.$feedback.success('删除成功！')
              // this.$store.commit('getCartNum', this.cartItems.length)
              if (this.cartItems && this.cartItems.length <= 0) {
                this.isNull = true
              }
              // console.log(this.cartData, 11111)
              this.handleSelect()
              this.$parent.getCartData()
              // if (this.tableData.length === 0) {
              //   this.$parent.getCartData()
              // }
            }
          })
        })
        .catch(() => {
          this.$feedback('已取消删除！')
        })
    },
    batchRemove(list) {
      this.$confirm('亲，确定删除该商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          list.map((vItem, vIndex) => {
            this.tableData.map((item, index) => {
              // if (item.id === vItem.id) {
              //   this.tableData.splice(index, 1)
              // }
            })
          })
          const carIds = []
          list.map((res) => {
            // 赠品id不需要传
            if (!res.gift && !res.collocation) {
              carIds.push(res.id)
            }
          })
          const data = {
            ids: carIds.join(',')
          }
          getData.deleteCartGroup(data).then(
            (res) => {
              if (res.status === 200) {
                this.$feedback.success('删除成功！')
                if (this.cartItems && this.cartItems.length <= 0) {
                  this.isNull = true
                }
                this.tableData.map((res) => {
                  this.$set(res, 'isSelect', false)
                })
                this.handleSelect()
                this.$parent.getCartData()
              }
            },
            (res) => {
              this.$feedback(res.message)
            }
          )
        })
        .catch(() => {
          this.$feedback('已取消删除！')
        })
    },
    getActivityType(item) {
      if (!item.activityItemInfoDto) {
        return null
      }
      let o = item.activityItemInfoDto
      return o.activityInfoDto.activityType
    },
    async goSubmit(selectList) {
      if (selectList.length === 0 || !selectList) {
        this.$feedback('请选择你要购买的商品！')
      } else {
        const itemToOrderList = []
        const carIds = []
        var ladderIndex = null
        let groupCode = ''
        let groupId = ''
        let lotteryDrawId = ''
        selectList.map((res) => {
          // 如果是买赠和搭配购的商品不需要处理
          if (!res.collocation && !res.gift) {
            let item = {}
            item.activityCode = res.activityCode
            item.activityId = this.getActivityType(res) === 3 ? null : res.activityId
            item.activityType = this.getActivityType(res)
            item.dealerId = res.dealerId
            item.itemId = res.itemId
            item.quantity = res.quantity
            item.skuId = res.skuId
            if (res.extra && res.extra.groupCode) {
              groupCode = res.extra.groupCode
            }
            res.extra && (groupId = res.extra.groupId)
            itemToOrderList.push(item)
            // 遍历搭配商品
            res.bizCollectionCartItemVOS &&
              res.bizCollectionCartItemVOS.forEach((obj) => {
                let itemObj = {}
                itemObj.itemId = obj.itemId
                itemObj.quantity = obj.quantity || 1
                itemObj.skuId = obj.skuId
                itemToOrderList.push(itemObj)
              })
            carIds.push(res.id)
            ladderIndex = res.extra && res.extra.ladderIndex
            lotteryDrawId = this.getActivityType(res) === 3 ? res.activityId : ''
          }
        })

      // 可转赠神券活动 先验证卡券是否本人持有且未激活 携带神券参数
      let couponParams = {}
      const { giveMagicCouponNum, giveMagicActivityId, givePublishId } = selectList.find(i => i.extra && i.extra.giveMagicCouponNum)?.extra || {}
      if (giveMagicCouponNum) {
        // 先验证卡券状态是否属于自己
        const { data: couponDetail } = await getCanGiveCouponDetail({ couponCode: giveMagicCouponNum })
        let userInfo = getStorage('userInfo')
        if (couponDetail.mobile === userInfo.mobile) {
          if (couponDetail.activeStatus === '0') {
            couponParams = {
              giveMagicActivityId,
              giveMagicCouponNum,
              givePublishId
            }
          }
        } else {
          this.$feedback('商品关联卡券已被他人领取，下单后无法激活卡券')
        }
      }

        const data = {
          ...couponParams,
          itemToOrderList: itemToOrderList,
          // orderType: 1,
          // payType: 1,
          orderChannel: 1,
          cartIds: carIds,
          groupId,
          terminal: 1,
          vmId: 1,
          ladderIndex: ladderIndex
        }
        if (lotteryDrawId) {
          data.lotteryDrawId = lotteryDrawId
        }
        if (groupCode) {
          data.groupCode = groupCode
        }
        getData.goBuy(data).then(
          (res) => {
            if (res.status === 200) {
              this.$feedback.success('下单成功！')
              // this.placeOrderDelete(selectList)
              // this.cartItems.length -= this.checkedItems.length
              // this.$store.commit('getCartNum', [...this.cartItems, ...this.offShelf, ...this.sellout].length)
              this.isSubmit = true
              this.$router.push({
                name: 'order-confirm',
                params: { orderId: res.data }
              })
            } else {
              if (res.message === 'trade.buy.exist.unpaid.order') {
                this.$feedback('您有订单未支付')
              } else {
                this.$feedback(res.message)
              }
            }
          },
          (res) => {
            this.$feedback(res.message)
          }
        )
      }
    },
    // 下单成功删除商品
    placeOrderDelete(list) {
      list.forEach((vItem, vIndex) => {
        this.tableData.forEach((item, index) => {
          if (item.itemId === vItem.itemId) {
            this.tableData.splice(index, 1)
          }
        })
      })
      const carIds = []
      list.map((res) => {
        carIds.push(res.id)
      })
      const data = {
        ids: carIds.join(',')
      }
      getData.deleteCartGroup(data).then((res) => {
        if (res.status === 200) {
          // this.$feedback.success('删除成功！')
          // this.$store.commit('getCartNum', [...this.cartItems, ...this.offShelf, ...this.sellout].length)
          if (this.cartItems && this.cartItems.length <= 0) {
            this.isNull = true
          }
        }
      })
    },
    // sku格式转化
    getSelectedAttr(sku) {
      if (sku && 'length' in sku) {
        return sku.reduce((total, next, cindex, arr) => {
          return total + (cindex === arr.length - 1 ? next.attrVal : `${next.attrVal}/`)
        }, '')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.tableRow {
  text-align: center;
  .tableCell {
    .goodsMessage {
      display: flex;
      .goodsImg {
        width: 202px;
        height: 143px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .text {
        margin-top: 17px;
        margin-left: 14px;
        .name {
          max-width: 300px;
          min-height: 25px;
          font-size: 18px;
          text-align: left;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          .activityTag {
            background: #df3d36;
            color: white;
            padding: 1.5px 4px;
            // margin-right: 8px;
            height: 18px;
            font-size: 13px;
            font-family: PingFangSC;
            font-weight: 500;
            line-height: 18px;
          }
          .deposit-tag {
            margin-right: 5px;
            background: linear-gradient(145deg, #ef5d42 0%, #da1f46 100%);
          }
        }
        .type {
          margin-top: 10px;
          text-align: left;
          min-height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        .sellOut {
          // width: 52px;
          padding: 0 5px;
          margin-top: 10px;
          height: 20px;
          border: 1px solid #333333;
          text-align: center;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
        }
        .activityCountDown {
          margin-top: 11px;
          font-size: 14px;
          color: #df3d36;
        }
      }
    }
    .price {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 25px;
    }
    .totalPrice {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #c6001f;
      line-height: 25px;
    }
  }
}
#cartTable {
  &::v-deep .el-table__expand-icon {
    display: none;
  }
  &::v-deep td {
    border-bottom: none !important;
  }
  &::v-deep .el-table__row--level-0 td {
    border-top: 1px solid #ebeef5 !important;
  }
  .collocationCommodity {
    width: 90px;
    height: 60px;
    margin-left: 150px;
    position: relative;
    top: 7px;
  }
  .describeTxt {
    position: relative;
    top: -10px;
  }
}
</style>
